import { css } from 'linaria';

export const priceView = css`
  span {
    font-size: 14px !important;
  }
`;

export const verticalButton = css`
  margin-top: var(--space-200);
`;
